import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext, useState } from 'react';
import classnames from 'classnames';
import LoadingIndicator from '../LoadingIndicator';
import isSSR from '../utils/isSSR';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useMessageListener } from '@wix/da-hooks/pkg/useMessageListener';
import s from './IframePopup.scss';
const POPUP_TITLE_HEIGHT = 68;
const IframePopup = ({ title, src, initialWidth = 400, initialHeight = 300, className, onMessage, style })=>{
    const isMobile = useContext(MobileContext);
    const [loaded, setLoaded] = useState(false);
    useMessageListener(onMessage);
    const isMobileClient = isMobile && !isSSR();
    const width = isMobileClient ? window.innerWidth : initialWidth;
    const height = isMobileClient ? window.innerHeight : initialHeight;
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: _object_spread({
            width,
            height
        }, style)
    }, title && /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title), /*#__PURE__*/ React.createElement("iframe", {
        title: title,
        className: classnames(s['iframe'], className),
        src: src,
        width: width,
        height: title ? height - POPUP_TITLE_HEIGHT : height,
        onLoad: ()=>setLoaded(true),
        style: style
    }), !loaded && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        coverMode: true,
        withOverlay: true,
        view: "daSymbol"
    }));
};
IframePopup.displayName = 'IframePopup';
export default IframePopup;
